import { Controller } from '@hotwired/stimulus'

// Drives the mobile (<lg) header menu: a full-screen panel that slides down
// from behind the bar. Replaces Bootstrap's collapse, whose height animation
// can't transition cleanly to a viewport-tall panel and whose `display:none`
// closed state blocks any transform. The slide lives in CSS (.header-menu /
// .is-open); this controller only flips the state and keeps ARIA in sync.
export default class extends Controller {
  static targets = ['menu', 'toggle']
  static values = { open: { type: Boolean, default: false } }

  toggle() {
    this.openValue = !this.openValue
  }

  close() {
    this.openValue = false
  }

  closeOnEscape(event) {
    if (event.key !== 'Escape' || !this.openValue) return

    this.openValue = false
    this.toggleTarget.focus()
  }

  openValueChanged(open) {
    this.menuTarget.classList.toggle('is-open', open)
    this.toggleTarget.setAttribute('aria-expanded', String(open))
  }
}
